import { useRouter } from 'next/router';
import { useCreateAccountCompany } from './companies.store';
import { Company } from './companies.types';
import { COMPANY_IMAGE } from '../routes/constants';
import { CompaniesFormTemplate } from '@modules/shared/components/companies/CompaniesFormTemplate';

const CompaniesNew = () => {
  const router = useRouter();
  const { mutate, isPending: isLoading } = useCreateAccountCompany({
    onSuccess: ({ company }) => {
      router.replace(COMPANY_IMAGE(company.id));
    },
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubmit = ({ id, ...data }: Company) => {
    const newCompany = { company: { ...data } };
    mutate(newCompany);
  };

  return (
    <CompaniesFormTemplate
      onClickHeaderArrow={() => history.back()}
      headerTitle="Empresa"
      title="Cadastrar empresa"
      description="Aqui você cadastra as informações da sua empresa."
      formProps={{
        onSubmit: handleSubmit,
      }}
      buttonLabel="Cadastrar empresa"
      isLoading={isLoading}
    />
  );
};

export default CompaniesNew;
